<template>
  <v-navigation-drawer
    app
    :mini-variant.sync="mini"
    :color="backgroundColor"
    class="left-menu-opacity sp-left-menu"
    :hide-overlay="true"
    mobile-break-point="0"
    :width="263"
  >
    <!-- 2022/01/17 Change menu bars background color -->
    <v-list-item
      v-if="mini"
      :class="`${
        $vuetify.theme.dark ? 'dark-menu-bars-color' : 'light-menu-bars-color'
      }`"
      dense
      class="pl-3 pb-0"
    >
      <v-btn x-small text icon @click.stop="mini = !mini">
        <v-icon
          :class="`${
            $vuetify.theme.dark
              ? 'dark-menu-text-color'
              : 'light-menu-text-color white--text'
          }`"
          :size="iconSize"
        >
          fa fa-bars
        </v-icon>
      </v-btn>
    </v-list-item>

    <v-list-item
      v-else
      :class="`${$vuetify.theme.dark ? 'dark-menu-bars-color' : ''}`"
      dense
      class="pl-0 pb-0"
    >
      <v-btn x-small text icon @click.stop="mini = !mini">
        <v-icon
          :class="[
            'custom-menu-bars',
            $vuetify.theme.dark
              ? 'dark-menu-text-color'
              : 'light-menu-text-color white--text',
          ]"
        >
          mdi-window-close
        </v-icon>
      </v-btn>
    </v-list-item>

    <div
      id="scroll-bar"
      class="scroll-bar"
      style="height: 96%; overflow-y: hidden; overflow-x: hidden"
    >
      <v-list flat tile>
        <v-btn v-show="isTop && isScroll" class="scrollUpIcon" small icon>
          <v-icon
            @mouseover.native="scrollDown"
            @mouseleave.native="leaveScroll"
            >mdi mdi-chevron-up</v-icon
          >
        </v-btn>
        <v-list-item-group
          v-for="item in getMenuList"
          v-if="!item.disabled"
          :key="item.id"
          class="pb-3"
        >
          <v-list-item
            v-if="!item.children"
            :to="item.href"
            :class="getColor(item.href)"
            @click.stop="itemClick(item.href, $event)"
            link
          >
            <v-list-item-icon class="pl-0 mr-0">
              <!-- /**
               * 2021.05.10 203737 SPKA-220 Modify Left Menu
               * Set tooltip when hover icon
               */ -->
              <v-tooltip top content-class="no-arrow">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="btn-tooltip">
                    <!-- <v-icon
                      :class="getColor(item.href)"
                      :size="iconSize"
                    >
                      {{ item.icon }}
                    </v-icon> -->
                    <icon-svg
                      :size="svgIconSize"
                      :active="getIconColor(item.href)"
                      :iconName="item.name"
                    />
                  </div>
                </template>
                <span>{{ item.name }}</span>
              </v-tooltip>
              <!-- <v-icon
                :class="getColor(item.href)"
                :size="iconSize"
              >
                {{ item.icon }}
              </v-icon> -->
            </v-list-item-icon>

            <v-list-item-content style="display: -webkit-box">
              <v-list-item-title
                :class="getColor(item.href)"
                class="menu-text-size pl-4"
                style="padding-top: 3px !important"
              >
                {{ item.name }}
              </v-list-item-title>
              <span @click.stop.prevent="openNewTab(item.href)">
                <icon-svg :size="20" iconName="open-new-tab" class="mr-2" />
              </span>
            </v-list-item-content>
          </v-list-item>

          <!-- Menu level 2 -->
          <v-menu
            offset-x
            right
            v-if="!!item.children"
            dense
            tile
            :close-on-content-click="false"
            open-on-click
            :value="subMenu"
            transition="slide-x-transition"
            :nudge-right="-1"
          >
            <template v-slot:activator="{ on, value }">
              <v-list-item v-on="on" link :class="getSubMenuColor(item.href)">
                <v-list-item-icon class="pl-0 mr-0">
                  <!-- /**
                    * 2021.05.10 203737 SPKA-220 Modify Left Menu
                    * Set tooltip when hover icon
                    */ -->
                  <v-tooltip top content-class="no-arrow">
                    <template v-slot:activator="{ on }">
                      <div v-on="on" class="btn-tooltip">
                        <!-- <v-icon
                          :class="getSubMenuColor(item.href)"
                          :size="iconSize"
                        >
                          {{ item.icon }}
                        </v-icon> -->
                        <icon-svg
                          :size="svgIconSize"
                          :active="getSubMenuIconColor(item.href)"
                          :iconName="item.name"
                        />
                      </div>
                    </template>
                    <span>{{ item.name }}</span>
                  </v-tooltip>
                  <!-- <v-icon
                    :class="getSubMenuColor(item.href)"
                    :size="iconSize"
                  >
                    {{ item.icon }}
                  </v-icon> -->
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title
                    :class="getSubMenuColor(item.href)"
                    class="menu-text-size pl-4 pt-1"
                  >
                    {{ item.name }}
                  </v-list-item-title>
                </v-list-item-content>

                <v-list-item-icon style="padding-top: 4.5px !important">
                  <v-icon
                    :class="`${getSubMenuColor(item.href)} ${
                      value ? 'fa-rotate-180' : ''
                    }`"
                    :size="arrowIconSize"
                  >
                    fa fa-chevron-right
                  </v-icon>
                </v-list-item-icon>
              </v-list-item>
            </template>

            <div>
              <v-list
                flat
                tile
                class="left-menu-opacity"
                :color="backgroundColor"
              >
                <v-subheader
                  :inset="false"
                  :class="getSubHeaderColor(item.href)"
                >
                  {{ item.name }}
                </v-subheader>

                <v-list-item-group
                  v-for="childItem in item.children"
                  v-if="!childItem.disabled"
                  :key="childItem.id"
                  class="pb-3"
                >
                  <v-list-item
                    :to="childItem.href"
                    v-if="!childItem.children"
                    :class="getColor(childItem.href)"
                    @click.stop="itemClick(childItem.href, $event)"
                    link
                  >
                    <v-list-item-icon class="pl-0 mr-0">
                      <v-tooltip top content-class="no-arrow">
                        <span>{{ childItem.name }}</span>
                      </v-tooltip>
                    </v-list-item-icon>

                    <v-list-item-content style="display: -webkit-box">
                      <v-list-item-title
                        :class="getColor(childItem.href)"
                        class="menu-text-size pl-4"
                        style="padding-top: 3px !important"
                      >
                        {{ childItem.name }}
                      </v-list-item-title>
                      <span @click.stop.prevent="openNewTab(childItem.href)">
                        <icon-svg :size="20" iconName="open-new-tab" />
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- Menu level 3 -->
                  <v-menu
                    offset-x
                    right
                    v-if="!!childItem.children"
                    dense
                    tile
                    :close-on-content-click="false"
                    open-on-click
                    :value="subMenu"
                    transition="slide-x-transition"
                    :nudge-right="-1"
                  >
                    <template v-slot:activator="{ on, value }">
                      <v-list-item
                        link
                        v-on="on"
                        :class="getSubMenuColor(childItem.href)"
                      >
                        <v-list-item-content>
                          <v-list-item-title
                            :class="getSubMenuColor(childItem.href)"
                            class="menu-text-size pl-10 pt-1"
                          >
                            {{ childItem.name }}
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-icon style="padding-top: 4.5px !important">
                          <v-icon
                            :class="`${getSubMenuColor(childItem.href)} ${
                              value ? 'fa-rotate-180' : ''
                            }`"
                            :size="arrowIconSize"
                          >
                            fa fa-chevron-right
                          </v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                    </template>

                    <v-list
                      flat
                      tile
                      class="left-menu-opacity"
                      :color="backgroundColor"
                    >
                      <v-subheader
                        :inset="false"
                        :class="getSubHeaderColor(childItem.href)"
                      >
                        {{ childItem.name }}
                      </v-subheader>
                      <v-list-item-group
                        v-for="childThree in childItem.children"
                        :key="childThree.id"
                        class="pb-3"
                      >
                        <v-list-item
                          :to="childThree.href"
                          v-if="!childThree.children"
                          :class="getColor(childThree.href)"
                          @click.stop="itemClick(childThree.href, $event)"
                          link
                        >
                          <v-list-item-content style="display: -webkit-box">
                            <v-list-item-title
                              :class="getColor(childThree.href)"
                              class="menu-text-size px-10 pt-1"
                            >
                              {{ childThree.name }}
                            </v-list-item-title>
                            <span @click.stop.prevent="openNewTab(childThree.href)">
                              <icon-svg :size="20" iconName="open-new-tab" />
                            </span>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-menu>
                </v-list-item-group>
              </v-list>
            </div>
          </v-menu>
        </v-list-item-group>
        <v-btn v-show="isBottom && isScroll" class="scrollBotIcon" small icon>
          <v-icon @mouseover.native="scrollUp" @mouseleave.native="leaveScroll"
            >mdi mdi-chevron-down</v-icon
          >
        </v-btn>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import $ from "jquery";
// 2021.12.1 SPKA-297 svg icon
import IconSvg from "@/vue-caas/components/IconBase.vue";
/**
 * icon search :: https://fontawesome.com/v4.7.0/icons/
 *
 * primary
 * secondary
 * info
 * success
 * default
 * warning
 * error
 */
export default {
  components: {
    IconSvg, // 2021.12.1 SPKA-297 svg icon
  },
  data() {
    return {
      drawer: true,
      color: "background2",
      menuItems: [],
      mini: true,
      iconSize: "16px !important",
      textSize: "14px",
      arrowIconSize: "16px !important",
      subMenu: undefined,
      prevUrl: "",
      timestamp: "",
      isTop: false,
      isBottom: false,
      isScroll: false,
      amount: "",
      svgIconSize: 24,
    };
  },
  mounted() {
    document
      .getElementById("scroll-bar")
      .addEventListener("scroll", this.handleScroll);
  },
  created() {
    /**
     * 2021.01.10 203737 SPKA-220 Modify Left Menu
     */
    window.addEventListener("click", (e) => {
      if (!this.$el.contains(e.target)) {
        if (!this.mini) {
          this.mini = true;
        }
      }
    });
    window.addEventListener("resize", this.handleResize);
    this.prevUrl = decodeURI(this.$route.path);
    this.$store.dispatch("getMenuList").then(() => {
      const tmpDefaultMenuList = this.$store.getters.menuList;

      const admMenuList = this._getAdmMenuList(tmpDefaultMenuList);
      const compAdmMenuList = this._getCompAdmMenuList(tmpDefaultMenuList);
      const extMenuList = this._getExtMenuList(tmpDefaultMenuList);
      // alert(JSON.stringify(extMenuList));

      this.$store
        .dispatch("getUser", { usrId: this.$cookies.get("user-id") })
        .then(() => {
          const menuListStr = this.$store.getters.user.menuAuth;

          if (
            menuListStr === null ||
            menuListStr === "" ||
            menuListStr === undefined
          ) {
            const tmpMenuList = JSON.parse(
              JSON.stringify(this.$store.getters.menuList)
            );

            for (let i = tmpMenuList.length - 1; i >= 0; i -= 1) {
              const tmpMenu = tmpMenuList[i];
              if (tmpMenu.children === undefined) {
                if (
                  compAdmMenuList.indexOf(tmpMenu.id) > -1 &&
                  this.$cookies.get("comp-adminrepo-use-yn") === "N"
                ) {
                  tmpMenuList.splice(i, 1);
                  continue;
                }
                if (
                  admMenuList.indexOf(tmpMenu.id) > -1 &&
                  Number(this.$cookies.get("use-grade")) < 3
                ) {
                  tmpMenuList.splice(i, 1);
                  continue;
                }
                if (extMenuList.indexOf(tmpMenu.id) > -1) {
                  tmpMenuList[i].external = tmpMenuList[i].href;
                  tmpMenuList[i].href = `/external?url=${tmpMenuList[i].href}`;
                }
              } else {
                let disabledCnt = 0;
                tmpMenuList[i].disabled = !this.$auth.manage;
                for (let j = tmpMenu.children.length - 1; j >= 0; j -= 1) {
                  const tmpChild = tmpMenu.children[j];
                  if (
                    compAdmMenuList.indexOf(tmpChild.id) > -1 &&
                    this.$cookies.get("comp-adminrepo-use-yn") === "N"
                  ) {
                    tmpMenuList[i].children.splice(j, 1);
                    continue;
                  }
                  if (
                    admMenuList.indexOf(tmpChild.id) > -1 &&
                    Number(this.$cookies.get("use-grade")) < 3
                  ) {
                    tmpMenuList[i].children.splice(j, 1);
                    continue;
                  }
                  if (extMenuList.indexOf(tmpChild.id) > -1) {
                    tmpMenuList[i].children[j].external =
                      tmpMenuList[i].children[j].href;
                    tmpMenuList[i].children[
                      j
                    ].href = `/external?url=${tmpMenuList[i].children[j].href}`;
                  }
                }

                if (tmpMenu.children.length === 0) {
                  tmpMenuList.splice(i, 1);
                  continue;
                }
              }
            }

            this.menuItems = tmpMenuList;
          } else {
            const menuList = JSON.parse(menuListStr);
            const tmpMenuList = [];
            for (let i = 0; i < menuList.length; i += 1) {
              const tmpMenu = menuList[i];

              for (let k = 0; k < tmpDefaultMenuList.length; k += 1) {
                const tmpDefaultMenu = tmpDefaultMenuList[k];

                if (tmpDefaultMenu.id === tmpMenu.id) {
                  if (tmpDefaultMenu.href !== undefined) {
                    tmpMenu.href = tmpDefaultMenu.href;
                    break;
                  }
                }
              }

              if (
                compAdmMenuList.indexOf(tmpMenu.id) > -1 &&
                this.$cookies.get("comp-adminrepo-use-yn") === "N"
              ) {
                continue;
              }
              if (
                admMenuList.indexOf(tmpMenu.id) > -1 &&
                Number(this.$cookies.get("use-grade")) < 3
              ) {
                continue;
              }
              if (extMenuList.indexOf(tmpMenu.id) > -1) {
                tmpMenu.external = btoa(tmpMenu.href);
                tmpMenu.href = `/external?code=${tmpMenu.external}`;
              }

              if (tmpMenu.select !== undefined) {
                if (tmpMenu.select) {
                  tmpMenuList.push(tmpMenu);
                }
              } else {
                const tmpParent = JSON.parse(JSON.stringify(tmpMenu));
                tmpParent.children = [];

                for (let j = 0; j < tmpMenu.children.length; j += 1) {
                  const tmpChild = tmpMenu.children[j];

                  for (let k = 0; k < tmpDefaultMenuList.length; k += 1) {
                    const tmpDefaultMenu = tmpDefaultMenuList[k];
                    if (
                      tmpDefaultMenu.children &&
                      tmpDefaultMenu.children.length > 0
                    ) {
                      // 2022.06.21 213979 SPKA-477 add menu level 3
                      for (
                        let l = 0;
                        l < tmpDefaultMenu.children.length;
                        l += 1
                      ) {
                        const tmpMenuChild = tmpDefaultMenu.children[l];
                        // if (tmpMenuChild.children && tmpMenuChild.children.length > 0) {
                        if (
                          tmpMenuChild.id === tmpChild.id &&
                          tmpChild.select
                        ) {
                          tmpChild.children = tmpMenuChild.children;
                          break;
                        }
                        // }
                      }
                    }

                    if (tmpDefaultMenu.id === tmpChild.id) {
                      tmpChild.href = tmpDefaultMenu.href;
                      break;
                    }
                  }

                  if (
                    compAdmMenuList.indexOf(tmpChild.id) > -1 &&
                    this.$cookies.get("comp-adminrepo-use-yn") === "N"
                  ) {
                    continue;
                  }
                  if (
                    admMenuList.indexOf(tmpChild.id) > -1 &&
                    Number(this.$cookies.get("use-grade")) < 3
                  ) {
                    continue;
                  }
                  if (extMenuList.indexOf(tmpChild.id) > -1) {
                    tmpChild.external = tmpChild.href;
                    tmpChild.href = `/external?url=${tmpChild.href}`;
                  }

                  if (tmpChild.select) {
                    tmpParent.children.push(tmpChild);
                  }
                }

                if (tmpParent.children.length > 0) {
                  tmpMenuList.push(tmpParent);
                }
              }
            }
            this.menuItems = tmpMenuList;
          }
        });
    });
  },

  computed: {
    ...mapState("common", {
      repomenuMode: "repomenuMode",
      // 2021.3.25 203728 SPKA-57 issue 26
      cmpIdLeftMenu: "cmpIdLeftMenu",
      isDlb: "isDlb",
    }),
    backgroundColor() {
      return this.$vuetify.theme.dark ? "#090A11" : "#FFFFFF";
    },
    getMenuList() {
      // 2021.3.30 203728 SPKA-57 issue 26
      // If company not ownr => show only 4 menu
      if (this.cmpIdLeftMenu !== this.$cookies.get("ownr-id") && !this.isDlb) {
        let ownrMenu = [];
        let arrMenu = [
          "Dashboard",
          "Transaction Log",
          "Process Setup",
          "Report",
        ];
        this.menuItems.forEach((item) => {
          if (item.children == undefined) {
            if (arrMenu.includes(item.name)) {
              item.disabled = false;
              ownrMenu.push(item);
            }
          } else {
            if (arrMenu.includes(item.name)) {
              item.disabled = false;
              ownrMenu.push(item);
            }
            item.children.forEach((childItem) => {
              if (arrMenu.includes(childItem.name)) {
                childItem.disabled = false;
                ownrMenu.push(childItem);
              }
            });
          }
        });
        return ownrMenu;
      } else if (this.repomenuMode) {
        let repoMenu = [];
        let arrMenu = [
          "Data Anlalysis",
          "Repository Manager",
          "Mapper",
          "Map Builder",
          "FlatFile Layout",
          "Mapping Definition",
          "Reference Files",
        ];
        this.menuItems.forEach((item) => {
          if (item.children == undefined) {
            if (arrMenu.includes(item.name)) {
              item.disabled = false;
              repoMenu.push(item);
            }
          } else {
            if (arrMenu.includes(item.name)) {
              item.disabled = false;
              repoMenu.push(item);
            }
            item.children.forEach((childItem) => {
              if (arrMenu.includes(childItem.name)) {
                childItem.disabled = false;
                repoMenu.push(childItem);
              }
            });
          }
        });
        return repoMenu;
      } else {
        let modifiedMenu = [];
        this.menuItems.forEach((item) => {
          // console.log('this.menuItems',item.name)
          if (item.name == "Codes" && !this.isDlb) {
            item.disabled = true;
          }
          if (item.children == undefined) {
            if (item.name == "Repository Manager") {
              item.disabled = true;
            }
            modifiedMenu.push(item);
          } else {
            let tempMenuList = [];
            item.children.forEach((childItem) => {
              if (childItem.name == "Repository Manager") {
                childItem.disabled = true;
              }
              if (childItem.name == "Codes" && this.isDlb) {
                childItem.disabled = true;
              }
              tempMenuList.push(childItem);
            });

            item.children = tempMenuList;
            modifiedMenu.push(item);
          }
        });
        return modifiedMenu;
        // return this.menuItems;
      }
    },
  },

  methods: {
    // 10/23/2020 Fix common Menu Screen issue 8 change the scroll type to such like Chrome bookmark bar
    scroll() {
      let a = this;
      let amount = this.amount;
      $("#scroll-bar").animate(
        {
          scrollTop: amount,
        },
        100,
        "linear",
        function () {
          if (amount != "") {
            a.scroll();
          }
        }
      );
    },
    scrollDown() {
      this.amount = "-=45";
      this.scroll();
    },
    scrollUp() {
      this.amount = "+=45";
      this.scroll();
    },
    leaveScroll() {
      this.amount = "";
      $("#scroll-bar").stop();
    },
    openNewTab(url) {
      window.open(url, '_blank');
    },
    handleScrollCommon(param) {
      this.isScroll = true;
      if (param.scrollTop == 0) {
        this.isTop = false;
        this.isBottom = true;
        this.amount = "";
        $("#scroll-bar").stop();
      }
      if (
        param.scrollHeight - param.scrollTop - param.clientHeight <= 0 &&
        param.scrollTop != 0
      ) {
        this.isTop = true;
        this.isBottom = false;
        this.amount = "";
        $("#scroll-bar").stop();
      }
      if (
        param.scrollTop != 0 &&
        param.scrollHeight - param.scrollTop - param.clientHeight > 0
      ) {
        this.isTop = true;
        this.isBottom = true;
      }
    },
    handleScroll(e) {
      this.handleScrollCommon(e.path[0]);
    },
    handleResize() {
      if (
        document.getElementById("scroll-bar").scrollHeight <=
        document.getElementById("scroll-bar").clientHeight
      ) {
        this.isTop = false;
        this.isBottom = false;
        this.isScroll = false;
      } else {
        this.handleScrollCommon(document.getElementById("scroll-bar"));
      }
    },
    itemClick(url, event) {
      if (this.sameRoute(url)) {
        this.$emit("refresh-page", {
          timestamp: new Date().getTime(),
          url: url,
        });
        // this.$router.go(url);
      } else {
        if (event.ctrlKey === false) {
          this.$router.push(url).catch(() => {});
        }
        this.prevUrl = decodeURI(this.$route.path);
      }
      this.hoverMenu(true);
    },
    getColor(url) {
      const urlWithoutParam =
        url !== undefined ? url.replace(/\?.*$/g, "") : url;
      return decodeURI(this.$route.path) !== urlWithoutParam
        ? `${
            this.$vuetify.theme.dark
              ? "dark-menu-text-color"
              : "light-menu-text-color"
          }`
        : `${
            this.$vuetify.theme.dark
              ? "blue--text"
              : "black--text font-semibold bg-active"
          }`;
    },
    // 2021.12.03 213960 menu icon color
    getIconColor(url) {
      const urlWithoutParam =
        url !== undefined ? url.replace(/\?.*$/g, "") : url;
      return decodeURI(this.$route.path) !== urlWithoutParam ? false : true;
    },
    sameRoute(url) {
      const urlWithoutParam =
        url !== undefined ? url.replace(/\?.*$/g, "") : url;
      return this.prevUrl == urlWithoutParam ? true : false;
    },
    // 2021.12.03 213960 menu icon color
    getSubMenuColor(url) {
      const urlWithoutParam =
        url !== undefined ? url.replace(/\?.*$/g, "") : url;
      return this.$route.path.indexOf(urlWithoutParam) === -1
        ? `${
            this.$vuetify.theme.dark
              ? "dark-menu-text-color"
              : "light-menu-text-color"
          }`
        : `${
            this.$vuetify.theme.dark
              ? "blue--text"
              : "black--text font-semibold bg-active"
          }`;
    },
    getSubHeaderColor(url) {
      const urlWithoutParam =
        url !== undefined ? url.replace(/\?.*$/g, "") : url;
      return this.$route.path.indexOf(urlWithoutParam) === -1
        ? `${
            this.$vuetify.theme.dark
              ? "dark-menu-text-color"
              : "light-menu-text-color"
          }`
        : `${
            this.$vuetify.theme.dark
              ? "blue--text"
              : "black--text font-semibold"
          }`;
    },
    getSubMenuIconColor(url) {
      const urlWithoutParam =
        url !== undefined ? url.replace(/\?.*$/g, "") : url;
      return this.$route.path.indexOf(urlWithoutParam) === -1 ? false : true;
    },
    hoverMenu(miniFlg) {
      this.mini = miniFlg;
      setTimeout(() => {
        if (this.mini) {
          this.subMenu = this.subMenu === false ? undefined : false;
        }
      }, 50);
    },
    hoverExpandMenu(miniFlg) {
      this.mini = miniFlg;
      setTimeout(() => {
        if (this.mini) {
          this.subMenu = this.subMenu === false ? undefined : false;
        }
      }, 50);
    },
    _getAdmMenuList(tmpDefaultMenuList) {
      const admMenuList = [];
      for (let i = 0; i < tmpDefaultMenuList.length; i += 1) {
        const tmpMenu = tmpDefaultMenuList[i];
        if (tmpMenu.children === undefined) {
          if (tmpMenu.admFlg === "Y") {
            admMenuList.push(tmpMenu.id);
          }
        } else {
          for (let j = 0; j < tmpMenu.children.length; j += 1) {
            const tmpChild = tmpMenu.children[j];
            if (tmpChild.admFlg === "Y") {
              admMenuList.push(tmpChild.id);
            }
          }
        }
      }
      return admMenuList;
    },
    _getCompAdmMenuList(tmpDefaultMenuList) {
      const admMenuList = [];
      for (let i = 0; i < tmpDefaultMenuList.length; i += 1) {
        const tmpMenu = tmpDefaultMenuList[i];
        if (tmpMenu.children === undefined) {
          if (tmpMenu.compAdmFlg === "Y") {
            admMenuList.push(tmpMenu.id);
          }
        } else {
          for (let j = 0; j < tmpMenu.children.length; j += 1) {
            const tmpChild = tmpMenu.children[j];
            if (tmpChild.compAdmFlg === "Y") {
              admMenuList.push(tmpChild.id);
            }
          }
        }
      }
      return admMenuList;
    },
    _getExtMenuList(tmpDefaultMenuList) {
      const extMenuList = [];
      for (let i = 0; i < tmpDefaultMenuList.length; i += 1) {
        const tmpMenu = tmpDefaultMenuList[i];
        if (tmpMenu.children === undefined) {
          if (tmpMenu.extMenuFlg === "Y") {
            extMenuList.push(tmpMenu.id);
          }
        } else {
          for (let j = 0; j < tmpMenu.children.length; j += 1) {
            const tmpChild = tmpMenu.children[j];
            if (tmpChild.extMenuFlg === "Y") {
              extMenuList.push(tmpChild.id);
            }
          }
        }
      }
      return extMenuList;
    },
  },
};
</script>

<style lang="scss">
nav.sp-left-menu.v-navigation-drawer--mini-variant {
  width: 45px !important;
}
/* nav.v-navigation-drawer--is-mouseover {
    width: 300px !important;
  } */
.left-menu-opacity {
  opacity: 0.92;
}

.left-menu-opacity .v-list-item {
  padding-left: 10px !important;
}

.left-menu-opacity .v-list-item.v-list-item-dense {
  padding-left: 7px !important;
}
.menu-text-size {
  font-size: 14px;
  padding-left: 30px;
}
.dark-menu-text-color {
  color: #7d838d !important;
}
.left-menu-opacity .v-navigation-drawer__content {
  overflow-y: hidden;
}
.scrollBotIcon {
  position: absolute !important;
  bottom: 20px;
  width: 263px !important;
  z-index: 10;
  cursor: pointer;
  margin-left: 0;
  .mdi.mdi.mdi-chevron-down {
    width: 100%;
  }
}
.scrollUpIcon {
  position: absolute !important;
  top: 40px;
  z-index: 10;
  width: 263px !important;
  margin-left: 0;
  cursor: pointer;
  .mdi.mdi.mdi-chevron-up {
    width: 100%;
  }
}
/**
    * 2021.01.10 203737 SPKA-220 Modify Left Menu
    */
.theme--dark .left-menu-opacity .v-list-item--link:hover {
  background-color: rgb(245, 245, 245, 5%) !important;
}
.theme--light .left-menu-opacity .v-list-item--link:hover {
  background-color: #f1f5f8 !important;
  font-weight: 600;
}
.theme--dark .no-arrow.v-tooltip__content::after {
  border-width: 0px !important;
}
.theme--light .custom-menu-bars {
  padding: 21px;
  background-color: #24acf1;
}
</style>
